import type { IconName } from '@magicschool/spellbook/components/Icon';
import mime from 'mime/lite';

/**
 * Map file extension to icon name (educational file types)
 */
export const FILE_TYPE_ICONS: Record<string, IconName> = {
  // Documents
  pdf: 'file-text',
  doc: 'file-text',
  docx: 'file-text',
  txt: 'file-text',
  // Spreadsheets
  xls: 'file-spreadsheet',
  xlsx: 'file-spreadsheet',
  csv: 'file-spreadsheet',
  // Presentations
  ppt: 'presentation',
  pptx: 'presentation',
  // Images
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  gif: 'image',
  svg: 'image',
  webp: 'image',
  // Video
  mp4: 'file-video',
  mov: 'file-video',
  avi: 'file-video',
  webm: 'file-video',
  mkv: 'file-video',
  // Audio
  mp3: 'file-audio',
  wav: 'file-audio',
  ogg: 'file-audio',
  m4a: 'file-audio',
  // Archives
  zip: 'file-archive',
  rar: 'file-archive',
  '7z': 'file-archive',
  tar: 'file-archive',
  gz: 'file-archive',
};

/** Map icon name to accessible category label */
export const FILE_TYPE_LABELS: Record<string, string> = {
  'file-text': 'Document',
  'file-spreadsheet': 'Spreadsheet',
  presentation: 'Presentation',
  image: 'Image',
  'file-video': 'Video',
  'file-audio': 'Audio',
  'file-archive': 'Archive',
  file: 'File',
};

/**
 * Normalizes a file type string to a lowercase extension (without dot).
 * Accepts either a MIME type ("image/png") or an extension ("png" / ".png").
 */
export function normalizeFileType(fileType: string): string {
  if (fileType.includes('/')) {
    return mime.getExtension(fileType) ?? fileType.slice(fileType.indexOf('/') + 1);
  }
  const ext = fileType.startsWith('.') ? fileType.slice(1) : fileType;
  return ext.toLowerCase();
}

export function getFileTypeIcon(extension: string): IconName {
  return FILE_TYPE_ICONS[extension.toLowerCase()] ?? 'file';
}

export function getFileTypeLabel(iconName: IconName): string {
  return FILE_TYPE_LABELS[iconName] ?? 'File';
}
